import styled from "styled-components";

export const TextErrorForm = styled.span`
  display: block;
  text-align: center;
  color: var(--color-negative);
  font-size: var(--sz-text-2);
  font-family: var(--font-weg-4);
  margin: 1rem 0 -1rem;
`;
